module.exports = __webpack_public_path__ + "static/media/45.5a49763a.jpg";